export const MetaTagEndpoints = {
  linkPreview: () => `${process.env.API_SCRAPER}/api/v1/scraper`
}